(() => {
  if (window.acquaFilterUI) return;
  window.acquaFilterUI = true;

  const SECTION = ':is(.shopify-section.collection--section, .shopify-section.search--section)';
  const FILTER_LINK = '[data-acqua-filters] [data-filter-input], [data-acqua-filters] .active-filter-group__item, .productgrid--filters [data-filter-input], :is(.collection--section, .search--section) .active-filter-group__item, [data-acqua-clear], .filter-item-clear-all';
  const request = { controller: null, sequence: 0, navigationCount: 0 };
  const colourGroupCache = new Map();
  const PREVIEW_PARAMS = ['preview_theme_id', '_fd', 'pb'];
  const filterDrawer = { source: null, container: null, content: null, trigger: null, addedLoadedClass: false };
  const findSection = (scope = document) => {
    if (scope.nodeType === Node.ELEMENT_NODE && scope.matches(SECTION)) return scope;
    return scope.querySelector?.(SECTION) || null;
  };

  const previewURL = input => {
    const url = new URL(input, location.href);
    const current = new URL(location.href);
    PREVIEW_PARAMS.forEach(key => {
      if (!url.searchParams.has(key) && current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    return url;
  };

  function openFilterDrawer(trigger) {
    const section = trigger.closest(SECTION);
    const source = section?.querySelector('[data-productgrid-sidebar]');
    const container = document.querySelector('[data-modal-container]');
    const content = container?.querySelector('[data-modal-content]');
    if (!source?.querySelector('[data-acqua-filters]') || !container || !content) return false;
    closeFilterDrawer({ restoreFocus: false });
    filterDrawer.source = source;
    filterDrawer.container = container;
    filterDrawer.content = content;
    filterDrawer.trigger = trigger;
    filterDrawer.addedLoadedClass = !document.body.classList.contains('modal-loaded');
    while (source.firstChild) content.appendChild(source.firstChild);
    container.classList.add('modal--productgrid-sidebar');
    container.setAttribute('role', 'dialog');
    container.setAttribute('aria-modal', 'true');
    container.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-loaded', 'modal-visible');
    document.body.dataset.acquaFilterDrawer = 'open';
    document.body.setAttribute('data-current-modal', source.id || 'productgrid-sidebar');
    content.querySelectorAll('[data-modal-close]').forEach(button => {
      if (button.dataset.acquaDrawerCloseReady) return;
      button.dataset.acquaDrawerCloseReady = 'true';
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeFilterDrawer();
      }, true);
    });
    content.querySelector('[data-modal-close], button, a, input, select')?.focus({ preventScroll: true });
    return true;
  }

  function closeFilterDrawer({ restoreFocus = true } = {}) {
    const content = filterDrawer.content || document.querySelector('[data-modal-container] [data-modal-content]');
    const source = filterDrawer.source || findSection(document)?.querySelector('[data-productgrid-sidebar]');
    const container = filterDrawer.container || content?.closest('[data-modal-container]');
    if (!source || !content?.querySelector('[data-acqua-filters]')) return false;
    while (content.firstChild) source.appendChild(content.firstChild);
    container?.classList.remove('modal--productgrid-sidebar', 'modal--productgrid-filters');
    container?.removeAttribute('aria-modal');
    container?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-visible');
    if (filterDrawer.addedLoadedClass) document.body.classList.remove('modal-loaded');
    document.body.dataset.acquaFilterDrawer = 'closed';
    document.body.removeAttribute('data-current-modal');
    const trigger = filterDrawer.trigger;
    filterDrawer.source = null;
    filterDrawer.container = null;
    filterDrawer.content = null;
    filterDrawer.trigger = null;
    filterDrawer.addedLoadedClass = false;
    if (restoreFocus && trigger?.isConnected) trigger.focus({ preventScroll: true });
    return true;
  }

  function preserveQuery(link) {
    const url = new URL(link.href, location.href);
    const current = new URL(location.href);
    const allowed = ['q', 'sort_by', 'view', 'grid_list', 'type', 'options[prefix]'];
    const preserveFilters = link.hasAttribute('data-acqua-preserve-query');
    new Set(current.searchParams.keys()).forEach(key => {
      if ((preserveFilters && key.startsWith('filter.')) || allowed.includes(key)) {
        url.searchParams.delete(key);
        current.searchParams.getAll(key).forEach(value => url.searchParams.append(key, value));
      }
    });
    url.searchParams.delete('page');
    link.href = url.toString();
    link.removeAttribute('data-acqua-preserve-query');
  }

  function linkURL(link) {
    const url = new URL(link.href || link.dataset.url, location.href);
    const section = link.closest(SECTION);
    const landing = link.closest('[data-acqua-colour-landing]') || section?.querySelector('[data-acqua-colour-landing]');
    if (!landing) return url.href;
    const colourParam = link.dataset.name;
    const groupParam = link.closest('[data-acqua-filter-key]')?.dataset.acquaFilterKey;
    const isColourAction = link.hasAttribute('data-acqua-colour-value-label') ||
      Boolean(colourParam && (colourParam === landing.dataset.acquaColourParam || groupParam === landing.dataset.acquaColourParam));
    if (!isColourAction) return url.href;
    const current = new URL(location.href);
    new Set(current.searchParams.keys()).forEach(key => {
      if (key === 'page' || key === colourParam || url.searchParams.has(key)) return;
      current.searchParams.getAll(key).forEach(value => url.searchParams.append(key, value));
    });
    url.searchParams.delete('page');
    return url.href;
  }

  function selectedColourLabels(root) {
    try {
      const configured = JSON.parse(root.dataset.acquaColourSelected || '[]');
      if (Array.isArray(configured)) return configured.map(label => String(label).trim().toLocaleLowerCase()).filter(Boolean);
    } catch (_) {
      // Fall through to the server-rendered fallback selections.
    }
    return [...root.querySelectorAll('[data-acqua-filter-key] [data-filter-active]')]
      .map(link => (link.closest('[data-acqua-filter-value]')?.dataset.valueLabel || link.querySelector('.acqua-filter__label')?.textContent || '').trim().toLocaleLowerCase())
      .filter(Boolean);
  }

  function nativeColourGroup(scope, colourParam = '') {
    return [...scope.querySelectorAll('[data-acqua-filter-key]')].find(group => {
      if (colourParam && group.dataset.acquaFilterKey === colourParam) return true;
      const title = group.querySelector('.acqua-filter__title')?.textContent.trim().toLocaleLowerCase() ||
        group.querySelector('[data-filter-group-trigger]')?.textContent.trim().toLocaleLowerCase();
      return title === 'colour' || title === 'color';
    });
  }

  function configureNativeColours(group, root, selectedLabels) {
    const links = [...group.querySelectorAll('[data-acqua-filter-value] [data-filter-input]')];
    const selectedValues = links.filter(link => {
      const item = link.closest('[data-acqua-filter-value]');
      return selectedLabels.includes((item?.dataset.valueLabel || link.querySelector('.acqua-filter__label')?.textContent || '').trim().toLocaleLowerCase());
    });
    const selectedByParam = new Map();
    selectedValues.forEach(link => {
      const values = selectedByParam.get(link.dataset.name) || [];
      values.push(link.dataset.value);
      selectedByParam.set(link.dataset.name, values);
    });
    const base = new URL(root.dataset.acquaFilterBaseUrl, location.href);
    links.forEach(link => {
      const item = link.closest('[data-acqua-filter-value]');
      const active = selectedValues.includes(link);
      const values = [...(selectedByParam.get(link.dataset.name) || [])];
      const nextValues = active ? values.filter(value => value !== link.dataset.value) : [...values, link.dataset.value];
      const url = new URL(base.href);
      nextValues.forEach(value => url.searchParams.append(link.dataset.name, value));
      link.href = url.href;
      link.dataset.url = encodeURIComponent(`${url.pathname}${url.search}`);
      link.setAttribute('aria-checked', String(active));
      link.toggleAttribute('data-filter-active', active);
      item.dataset.filterOpen = String(active);
    });
    const heading = group.querySelector('[data-filter-group-trigger]');
    let selectedCount = heading?.querySelector('.acqua-filter__selected-count');
    if (selectedValues.length) {
      if (!selectedCount) {
        selectedCount = document.createElement('span');
        selectedCount.className = 'acqua-filter__selected-count';
        heading?.querySelector('.acqua-filter__title')?.insertAdjacentElement('afterend', selectedCount);
      }
      selectedCount.innerHTML = `${selectedValues.length}<span class="visually-hidden"> selected</span>`;
    } else {
      selectedCount?.remove();
    }
    root.dataset.acquaColourParam = links[0]?.dataset.name || '';
    const nativeByLabel = new Map(links.map(link => {
      const label = (link.closest('[data-acqua-filter-value]')?.dataset.valueLabel || '').trim().toLocaleLowerCase();
      return [label, link];
    }));
    const section = root.closest(SECTION);
    section?.querySelectorAll('[data-acqua-colour-value-label]').forEach(chip => {
      const label = chip.dataset.acquaColourValueLabel.trim().toLocaleLowerCase();
      const nativeLink = nativeByLabel.get(label);
      if (!nativeLink) return;
      chip.dataset.name = nativeLink.dataset.name;
      chip.dataset.value = nativeLink.dataset.value;
      const remaining = selectedValues.filter(link => link !== nativeLink);
      const url = new URL(base.href);
      const remainingByParam = new Map();
      remaining.forEach(link => {
        const values = remainingByParam.get(link.dataset.name) || [];
        values.push(link.dataset.value);
        remainingByParam.set(link.dataset.name, values);
      });
      remainingByParam.forEach((values, param) => values.forEach(value => url.searchParams.append(param, value)));
      chip.href = url.href;
      chip.dataset.url = `${url.pathname}${url.search}`;
    });
  }

  async function hydrateLanding(root) {
    if (!root.hasAttribute('data-acqua-colour-landing') || root.dataset.acquaColourHydrated || root.dataset.acquaColourHydrating) return;
    const baseURL = root.dataset.acquaFilterBaseUrl;
    if (!baseURL) return;
    root.dataset.acquaColourHydrating = 'true';
    const selectedLabels = selectedColourLabels(root);
    try {
      let groupHTML = colourGroupCache.get(baseURL);
      if (!groupHTML) {
        const response = await fetch(previewURL(baseURL).href, { headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Parent colour request failed (${response.status})`);
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const parentSection = findSection(parsed);
        const parentGroup = parentSection && nativeColourGroup(parentSection, root.dataset.acquaColourParam);
        if (!parentGroup) {
          const groups = parentSection ? [...parentSection.querySelectorAll('[data-acqua-filter-key]')].map(item => item.dataset.acquaFilterKey || '(unnamed)').join(', ') : '(section missing)';
          throw new Error(`Parent collection did not return a native Colour filter; groups: ${groups}`);
        }
        groupHTML = parentGroup.outerHTML;
        colourGroupCache.set(baseURL, groupHTML);
      }
      const template = document.createElement('template');
      template.innerHTML = groupHTML;
      const group = template.content.firstElementChild;
      if (!root.isConnected) return;
      const fallback = nativeColourGroup(root, root.dataset.acquaColourParam);
      if (!group || !fallback) throw new Error('Colour group could not be replaced');
      configureNativeColours(group, root, selectedLabels);
      const nativeBody = group.querySelector('[data-accordion-content]');
      const fallbackBody = fallback.querySelector('[data-accordion-content]');
      if (!nativeBody || !fallbackBody) throw new Error('Colour group body could not be replaced');
      fallbackBody.innerHTML = nativeBody.innerHTML;
      const nativeCount = group.querySelector('.acqua-filter__selected-count');
      const fallbackCount = fallback.querySelector('.acqua-filter__selected-count');
      if (nativeCount) {
        if (fallbackCount) fallbackCount.replaceWith(nativeCount.cloneNode(true));
        else fallback.querySelector('.acqua-filter__title')?.insertAdjacentElement('afterend', nativeCount.cloneNode(true));
      } else fallbackCount?.remove();
      fallback.dataset.acquaFilterKey = group.dataset.acquaFilterKey;
      fallback.dataset.valueOrder = group.dataset.valueOrder;
      fallback.dataset.valueLimit = group.dataset.valueLimit;
      delete fallback.dataset.acquaPresentationReady;
      initFilterGroup(fallback);
      root.dataset.acquaColourHydrated = 'true';
    } catch (error) {
      root.dataset.acquaColourHydrationFailed = 'true';
      root.dataset.acquaColourHydrationError = error.message || String(error);
      console.warn('[Acqua filters] Parent Colour hydration failed:', error);
      document.dispatchEvent(new CustomEvent('acqua:filters:error', { detail: { url: previewURL(baseURL).href, error } }));
    } finally {
      delete root.dataset.acquaColourHydrating;
    }
  }

  function initFilterGroup(group) {
    if (group.dataset.acquaPresentationReady) return;
    const list = group.querySelector('[data-filter-group-list]');
    if (!list) return;
    group.dataset.acquaPresentationReady = 'true';
    const items = [...list.querySelectorAll('[data-acqua-filter-value]')];
    const input = group.querySelector('[data-acqua-search-input]');
    const more = group.querySelector('[data-acqua-more]');
    const empty = group.querySelector('[data-acqua-no-match]');
    const limit = Math.max(1, Number(group.dataset.valueLimit) || 6);
    let expanded = false;
    if (group.dataset.valueOrder === 'numeric') {
      items.sort((a, b) => a.dataset.valueLabel.localeCompare(b.dataset.valueLabel, undefined, { numeric: true }));
      items.forEach(item => list.append(item));
    }
    const update = () => {
      const query = (input?.value || '').trim().toLocaleLowerCase();
      let matches = 0;
      let hidden = 0;
      items.forEach((item, index) => {
        const match = item.dataset.valueLabel.toLocaleLowerCase().includes(query);
        const active = item.dataset.filterOpen === 'true';
        item.hidden = !match || (!query && !expanded && index >= limit && !active);
        if (match) matches += 1;
        if (item.hidden && match) hidden += 1;
      });
      if (empty) empty.hidden = matches > 0;
      if (more) {
        more.hidden = Boolean(query) || (!hidden && !expanded);
        more.textContent = expanded ? 'Show fewer' : `Show all ${items.length}`;
        more.setAttribute('aria-expanded', String(expanded));
      }
    };
    if (input) {
      input.closest('[data-acqua-value-search]').hidden = false;
      input.addEventListener('input', update);
    }
    more?.addEventListener('click', () => { expanded = !expanded; update(); });
    update();
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-acqua-filters]').forEach(root => {
      if (root.dataset.ready) return;
      if (root.hasAttribute('data-acqua-colour-landing') && !root.dataset.acquaColourHydrated && !root.dataset.acquaColourHydrationFailed) {
        hydrateLanding(root).finally(() => init(root.closest(SECTION) || document));
      }
      root.dataset.ready = 'true';
      root.querySelectorAll('[data-acqua-filter-key]').forEach(initFilterGroup);
      root.addEventListener('keydown', event => {
        const choice = event.target.closest('[role="checkbox"][data-filter-input]');
        if (choice && event.key === ' ') { event.preventDefault(); choice.click(); }
      });
    });
    scope.querySelectorAll('[data-acqua-preserve-query], [data-acqua-clear]').forEach(preserveQuery);
  }

  function saveState(section) {
    const modalFilters = document.querySelector('.modal-visible :is(.modal--productgrid-sidebar, .modal--productgrid-filters) [data-acqua-filters]');
    const state = { groups: {}, drawer: Boolean(modalFilters) };
    const filterScope = modalFilters || section;
    filterScope.querySelectorAll('[data-acqua-filter-key]').forEach(group => {
      state.groups[group.dataset.acquaFilterKey] = {
        open: group.querySelector('[data-filter-group-trigger]')?.getAttribute('aria-expanded') === 'true' || group.querySelector('[data-accordion-content]')?.dataset.accordionState === 'open',
        expanded: group.querySelector('[data-acqua-more]')?.getAttribute('aria-expanded') === 'true',
        search: group.querySelector('[data-acqua-search-input]')?.value || ''
      };
    });
    return state;
  }

  function restoreState(section, state) {
    Object.entries(state.groups).forEach(([key, saved]) => {
      const group = [...section.querySelectorAll('[data-acqua-filter-key]')].find(item => item.dataset.acquaFilterKey === key);
      if (!group) return;
      if (saved.expanded && group.querySelector('[data-acqua-more]')?.getAttribute('aria-expanded') !== 'true') group.querySelector('[data-acqua-more]').click();
      const input = group.querySelector('[data-acqua-search-input]');
      if (input && saved.search) { input.value = saved.search; input.dispatchEvent(new Event('input', { bubbles: true })); }
      const trigger = group.querySelector('[data-filter-group-trigger]');
      const isOpen = trigger?.getAttribute('aria-expanded') === 'true' || group.querySelector('[data-accordion-content]')?.dataset.accordionState === 'open';
      if (trigger && saved.open !== isOpen) trigger.click();
    });
    if (state.drawer) section.querySelector('[data-productgrid-trigger-filters]')?.click();
  }

  function busy(section, value) {
    section?.classList.toggle('acqua-filter-loading', value);
    section?.setAttribute('aria-busy', String(value));
  }

  function sectionEvent(section, type) {
    const sectionId = section.querySelector('[data-section-id]')?.getAttribute('data-section-id');
    section.dispatchEvent(new CustomEvent(type, { bubbles: true, detail: { sectionId } }));
  }

  function syncBreadcrumbs(incoming) {
    if (!incoming.length) return;
    const current = [...document.querySelectorAll('[aria-label="breadcrumbs"]')];
    current.forEach((breadcrumb, index) => {
      const replacement = incoming[index] || incoming[incoming.length - 1];
      breadcrumb.replaceWith(replacement.cloneNode(true));
    });
  }

  function scheduleRange(range) {
    clearTimeout(range.acquaFilterTimeout);
    range.acquaFilterTimeout = setTimeout(() => {
      const formElement = range.form || range.closest('form');
      if (!formElement) return;
      const url = new URL(location.href);
      const form = new FormData(formElement);
      [...new Set(form.keys())].forEach(key => {
        url.searchParams.delete(key);
        form.getAll(key).filter(Boolean).forEach(value => url.searchParams.append(key, value));
      });
      url.searchParams.delete('page');
      navigate(url.href);
    }, 650);
  }

  async function navigate(input, { history = 'push' } = {}) {
    const startedAt = performance.now();
    const url = new URL(input, location.href);
    if (url.origin !== location.origin) return location.assign(url.href);
    const oldSection = findSection(document);
    if (!oldSection) return location.assign(url.href);
    const state = saveState(oldSection);
    const id = ++request.sequence;
    request.controller?.abort();
    request.controller = new AbortController();
    busy(oldSection, true);
    try {
      const response = await fetch(url.href, { headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', signal: request.controller.signal });
      if (!response.ok) throw new Error(`Filter request failed (${response.status})`);
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const newSection = findSection(parsed);
      if (!newSection) throw new Error('Filter response was missing its collection or search section');
      const incomingBreadcrumbs = [...parsed.querySelectorAll('[aria-label="breadcrumbs"]')].map(item => item.cloneNode(true));
      if (id !== request.sequence) return;
      if (!closeFilterDrawer({ restoreFocus: false })) document.querySelector('.modal-visible [data-modal-close]')?.click();
      sectionEvent(oldSection, 'shopify:section:unload');
      oldSection.replaceWith(newSection);
      request.navigationCount += 1;
      newSection.dataset.acquaFilterDurationMs = String(Math.round(performance.now() - startedAt));
      newSection.dataset.acquaFilterNavigationCount = String(request.navigationCount);
      syncBreadcrumbs(incomingBreadcrumbs);
      document.title = parsed.title;
      const incomingCanonical = parsed.querySelector('link[rel="canonical"]');
      const canonical = document.querySelector('link[rel="canonical"]');
      if (incomingCanonical && canonical) canonical.href = incomingCanonical.href;
      if (history === 'push') window.history.pushState({ acquaFilters: true }, '', url.href);
      sectionEvent(newSection, 'shopify:section:load');
      init(newSection);
      queueMicrotask(() => restoreState(newSection, state));
      window.scrollTo({ top: Math.max(0, newSection.getBoundingClientRect().top + window.scrollY - 16), behavior: 'auto' });
      document.dispatchEvent(new CustomEvent('acqua:filters:updated', { detail: { url: url.href, section: newSection } }));
    } catch (error) {
      if (error.name === 'AbortError') return;
      busy(oldSection, false);
      oldSection.dataset.acquaFilterError = error.message || String(error);
      console.warn('[Acqua filters] AJAX navigation failed; using full navigation:', error);
      document.dispatchEvent(new CustomEvent('acqua:filters:error', { detail: { url: url.href, error } }));
      location.assign(url.href);
    } finally {
      if (id === request.sequence) { busy(findSection(document), false); request.controller = null; }
    }
  }

  document.addEventListener('click', event => {
    const filterTrigger = event.target.closest('[data-productgrid-trigger-filters]');
    if (filterTrigger && filterTrigger.closest(SECTION)?.querySelector('[data-acqua-filters]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openFilterDrawer(filterTrigger);
      return;
    }
    const modalClose = event.target.closest('[data-modal-close]');
    if (modalClose?.closest('[data-acqua-filters]') && document.body.classList.contains('modal-visible')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeFilterDrawer();
      return;
    }
    if (filterDrawer.container && event.target === filterDrawer.container) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeFilterDrawer();
      return;
    }
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const sortButton = event.target.closest('[data-productgrid-trigger-sort-button]');
    if (sortButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const url = new URL(location.href);
      url.searchParams.set('sort_by', sortButton.value);
      url.searchParams.delete('page');
      navigate(url.href);
      return;
    }
    const link = event.target.closest(`${FILTER_LINK}, ${SECTION} .pagination--container a`);
    if (!link || link.matches('[aria-disabled="true"], [data-disabled]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    navigate(linkURL(link));
  }, true);

  window.addEventListener('keydown', event => {
    if (!filterDrawer.source) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeFilterDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...filterDrawer.content.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter(item => !item.hidden && item.getClientRects().length > 0);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  const desktopQuery = window.matchMedia('(min-width: 860px)');
  const returnDrawerOnDesktop = event => { if (event.matches) closeFilterDrawer({ restoreFocus: false }); };
  if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', returnDrawerOnDesktop);
  else desktopQuery.addListener(returnDrawerOnDesktop);

  document.addEventListener('change', event => {
    const range = event.target.closest('[data-filter-range]');
    if (range) {
      event.stopImmediatePropagation();
      scheduleRange(range);
      return;
    }
    const sort = event.target.closest('[data-productgrid-trigger-sort]');
    if (sort) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const url = new URL(location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      navigate(url.href);
    }
  }, true);

  document.addEventListener('input', event => {
    const range = event.target.closest('[data-filter-range]');
    if (!range) return;
    event.stopImmediatePropagation();
    scheduleRange(range);
  }, true);

  document.addEventListener('keyup', event => {
    const range = event.target.closest('[data-filter-range]');
    if (!range) return;
    event.stopImmediatePropagation();
    scheduleRange(range);
  }, true);

  window.addEventListener('popstate', () => navigate(location.href, { history: 'none' }));
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
